<template>
  <v-container fluid>




    <v-tabs v-model="tab" height="59" color="#fff" flat class="firstBar fixed-bar ma-0 pa-0 ">
      <v-tab href="#tab-1" class="tab" active-class="tab_color" color="#0482fb">Encaissement prime </v-tab>
      <v-tab href="#tab-2" active-class="tab_color">Reversements prime</v-tab>

    </v-tabs>


    <v-tabs-items v-model="tab">
      <v-tab-item value="tab-1">
        <v-data-table v-model="selected" class="pt-3" flat :loading="loading ? '#0482fb' : null" :headers="headers"
          :items="ContractsList" :items-per-page="5" sort-by="" item-key="_id" show-select>
          <template v-slot:top>
            <v-container fluid>
              <v-expansion-panels flat style="border: 1px solid #0482fb">
                <v-expansion-panel class="elevation-0">
                  <v-expansion-panel-header>
                    Tri / Recherche ...
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col cols="12" md="3">
                        <v-text-field outlined color="#0482fb" label="Date émission début" class="pt-5 pa-2"
                          prepend-inner-icon="mdi-magnify" v-model="encaissementPeriodStartDate" type="date" dense flat
                          background-color="grey lighten-4"></v-text-field></v-col>
                      <v-col cols="12" md="3">
                        <v-text-field outlined color="#0482fb" label="Date émission fin" class="pt-5 pa-2"
                          prepend-inner-icon="mdi-magnify" v-model="encaissementPeriodEndDate" type="date" dense flat
                          background-color="grey lighten-4"></v-text-field></v-col>
                      <v-col cols="12" md="2">
                        <v-autocomplete outlined :items="userFile" class="pt-5 pa-2 mx-2" prepend-inner-icon="mdi-magnify"
                          v-model="encaissementFileName" dense flat background-color="grey lighten-4"
                          label="Nom / Raison Sociale ...">
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="2">
                        <v-text-field outlined color="#0482fb" label="Numéro Police ..." class="pt-5 pa-2"
                          v-model="encaissementPoliceNumber" prepend-inner-icon="mdi-magnify" dense flat
                          background-color="grey lighten-4"></v-text-field></v-col>
                      <v-col cols="12" md="2">
                        <v-text-field outlined color="#0482fb" label="Numéro Avenant ..." class="pt-5 pa-2"
                          prepend-inner-icon="mdi-magnify" dense v-model="encaissementPlugged" flat
                          background-color="grey lighten-4"></v-text-field></v-col>

                      <v-col cols="12" md="2">
                        <v-text-field outlined color="#0482fb" label="Numéro Emission ..." class="pt-5 pa-2"
                          prepend-inner-icon="mdi-magnify" dense v-model="encaissementEmissionNumber" flat
                          background-color="grey lighten-4"></v-text-field></v-col>
                      <v-col cols="12" md="2">
                        <v-text-field outlined color="#0482fb" label="Numéro Quittance ..." class="pt-5 pa-2"
                          prepend-inner-icon="mdi-magnify" dense v-model="encaissementReceiptNumber" flat
                          background-color="grey lighten-4"></v-text-field></v-col>
                      <v-col cols="12" md="2">
                        <v-text-field outlined color="#0482fb" label="Numéro Client ..." class="pt-5 pa-2"
                          prepend-inner-icon="mdi-magnify" dense v-model="encaissementCustomerNumber" flat
                          background-color="grey lighten-4"></v-text-field></v-col>
                      <v-col cols="12" md="2">
                        <v-select outlined :items="companyNameList" class="pt-5 pa-2" prepend-inner-icon="mdi-magnify"
                          dense v-model="encaissementCompany" flat background-color="grey lighten-4"
                          label="Compagnie ..."></v-select></v-col>
                      <v-col cols="12" md="2">
                        <v-select outlined :items="productNameList" class="pt-5 pa-2" prepend-inner-icon="mdi-magnify"
                          dense v-model="encaissementProduct" flat background-color="grey lighten-4"
                          label="Produit"></v-select></v-col>
                      <v-col cols="12" md="2">
                        <v-select outlined :items="avenantList" class="pt-5 pa-2" prepend-inner-icon="mdi-magnify" dense
                          v-model="encaissementActionType" flat background-color="grey lighten-4"
                          label="Type d'avenant"></v-select></v-col>
                    </v-row>
                    <v-card-actions>
                      <v-btn class="red--text mr-2" outlined color="red" pill @click="cleanOnEnter">

                        Effacer
                      </v-btn>
                      <v-spacer></v-spacer>
                      <v-btn class="white--text mr-2" color="#0482fb" pill @click="onEnter">
                        <v-icon left>
                          mdi-magnify
                        </v-icon>
                        Appliquer la recherche
                      </v-btn>
                    </v-card-actions>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-container>
            <v-toolbar flat>
              <h4 class="text-h4 pageTitle ">Listing des emissions en attente d'encaissement prime</h4>

              <v-divider class="mx-4" inset vertical></v-divider>
              <h4 class="text-h4 pageTitle ">{{ selected.length ? selected.length : 0 }} sélections</h4>
              <!-- <v-switch v-model="showAllFil" label="Afficher toutes les données" color="#0482fb"
                @change="showAllFillData" class="pt-5"></v-switch> -->
            </v-toolbar>
            <v-btn color="#0482fb" dark class="mt-5 ml-5 mb-10" @click="applyEncaissementModal()">
              Encaisser la sélection
            </v-btn>
          </template>
          <template v-slot:item.name="{ item }">
            <td>
              {{ item.file.name }}
            </td>
          </template>
          <template v-slot:item.company="{ item }">
            <td>
              {{ item.company && item.company.name ? item.company.name : "" }}
            </td>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-menu elevation="0" right offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on" class="mr-10">
                  <v-icon color="success" size="30">mdi-forwardburger</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-tooltip bottom color="warning">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn class="ml-3" icon>
                      <v-icon size="20" @click="editItem(item)" v-bind="attrs" v-on="on"
                        color="warning">mdi-pencil-box-multiple-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>Modification du contrat sélectionné</span>
                </v-tooltip>
                <v-tooltip bottom color="black">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn class="ml-3" icon>
                      <v-icon size="20" @click="handleClickFacture(item)" color="black" v-bind="attrs" v-on="on">
                        mdi-cash-register</v-icon>
                    </v-btn>
                  </template>
                  <span>Facture</span>
                </v-tooltip>
                <!-- <v-tooltip bottom color="success">
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="ml-3" icon>
                  <v-icon
                    size="20"
                    color="success"
                    v-bind="attrs"
                    v-on="on"
                    @click="startNewContract(item)"
                    >mdi-checkbox-marked-circle-plus-outline</v-icon
                  >
                </v-btn>
              </template>
              <span>Mise en place d'un nouveau contrat</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="ml-3" icon>
                  <v-icon
                    size="20"
                    v-bind="attrs"
                    v-on="on"
                    @click="getSinisterDeclaration(item)"
                    >mdi-ambulance</v-icon
                  >
                </v-btn>
              </template>
              <span>Déclaration d'un sinistre</span>
            </v-tooltip>

            <v-tooltip bottom color="error">
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="ml-3" icon>
                  <v-icon
                    @click="initCancelContract(item)"
                    v-bind="attrs"
                    v-on="on"
                    size="20"
                    color="error"
                    >mdi-book-cancel-outline</v-icon
                  >
                </v-btn>
              </template>
              <span>Annuler ce contrat</span>
            </v-tooltip> -->
              </v-list>
            </v-menu>
          </template>
        </v-data-table>
      </v-tab-item>
      <v-tab-item value="tab-2">
        <v-data-table v-model="selectedReverse" class="pt-3" flat :loading="loading ? '#0482fb' : null" :headers="headers"
          :items="ContratOtherList" :items-per-page="5" sort-by="" item-key="_id" show-select>
          <template v-slot:top>
            <v-container fluid>
              <v-expansion-panels flat style="border: 1px solid #0482fb">
                <v-expansion-panel class="elevation-0">
                  <v-expansion-panel-header>
                    Tri / Recherche ...
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col cols="12" md="3">
                        <v-text-field outlined color="#0482fb" label="Date encaissement début" class="pt-5 pa-2"
                          prepend-inner-icon="mdi-magnify" v-model="primeRepaymentDateStart" type="date" dense flat
                          background-color="grey lighten-4"></v-text-field></v-col>
                      <v-col cols="12" md="3">
                        <v-text-field outlined color="#0482fb" label="Date encaissement fin" class="pt-5 pa-2"
                          prepend-inner-icon="mdi-magnify" v-model="primeRepaymentDateEnd" type="date" dense flat
                          background-color="grey lighten-4"></v-text-field></v-col>
                      <!-- <v-col cols="12" md="3">
                    <v-text-field outlined  
                      color="#0482fb"
                      label="Date effet début"
                      class="pt-5 pa-2"
                      prepend-inner-icon="mdi-magnify"
                      v-model="effectStartDate"
                      type="date"
                       
                      dense
                      
                      flat
                      background-color="grey lighten-4"
                      
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field outlined  
                      color="#0482fb"
                      label="Date effet fin"
                      class="pt-5 pa-2"
                      prepend-inner-icon="mdi-magnify"
                      v-model="effectEndDate"
                      type="date"
                       
                      dense
                      
                      flat
                      background-color="grey lighten-4"
                      
                    ></v-text-field
                  ></v-col>
                  <v-col cols="12" md="3">
                    <v-text-field outlined  
                      color="#0482fb"
                      label="Date echéance début"
                      class="pt-5 pa-2"
                      prepend-inner-icon="mdi-magnify"
                      v-model="dueStartDate"
                      type="date"
                       
                      dense
                      
                      flat
                      background-color="grey lighten-4"
                      
                    ></v-text-field
                  ></v-col>
                  <v-col cols="12" md="3">
                    <v-text-field outlined  
                      color="#0482fb"
                      label="Date echéance fin"
                      class="pt-5 pa-2"
                      prepend-inner-icon="mdi-magnify"
                      v-model="dueEndDate"
                      type="date"
                       
                      dense
                      
                      flat
                      background-color="grey lighten-4"
                      
                    ></v-text-field
                  ></v-col> -->
                      <v-col cols="12" md="2">
                        <v-autocomplete outlined :items="userFile" class="pt-5 pa-2 mx-2" prepend-inner-icon="mdi-magnify"
                          v-model="fileName" dense flat background-color="grey lighten-4"
                          label="Nom / Raison Sociale ...">
                        </v-autocomplete>
                      </v-col>
                      <!-- <v-col cols="12" md="2">
                        <v-text-field outlined color="#0482fb" label="Nom / Raison Sociale ..." class="pt-5 pa-2"
                          prepend-inner-icon="mdi-magnify" dense v-model="fileName" flat
                          background-color="grey lighten-4"></v-text-field></v-col> -->
                      <v-col cols="12" md="2">
                        <v-text-field outlined color="#0482fb" label="Numéro Police ..." class="pt-5 pa-2"
                          v-model="policeNumber" prepend-inner-icon="mdi-magnify" dense flat
                          background-color="grey lighten-4"></v-text-field></v-col>
                      <v-col cols="12" md="2">
                        <v-text-field outlined color="#0482fb" label="Numéro Avenant ..." class="pt-5 pa-2"
                          prepend-inner-icon="mdi-magnify" dense v-model="plugged" flat
                          background-color="grey lighten-4"></v-text-field></v-col>
                      <v-col cols="12" md="2">
                        <v-text-field outlined color="#0482fb" label="Numéro Emission ..." class="pt-5 pa-2"
                          prepend-inner-icon="mdi-magnify" dense v-model="emissionNumber" flat
                          background-color="grey lighten-4"></v-text-field></v-col>
                      <v-col cols="12" md="2">

                        <v-text-field outlined color="#0482fb" label="Numéro Quittance ..." class="pt-5 pa-2"
                          prepend-inner-icon="mdi-magnify" dense v-model="receiptNumber" flat
                          background-color="grey lighten-4"></v-text-field></v-col>
                      <v-col cols="12" md="2">
                        <v-text-field outlined color="#0482fb" label="Numéro Client ..." class="pt-5 pa-2"
                          prepend-inner-icon="mdi-magnify" dense v-model="customerNumber" flat
                          background-color="grey lighten-4"></v-text-field></v-col>
                      <v-col cols="12" md="2">
                        <v-select outlined :items="companyNameList" class="pt-5 pa-2" prepend-inner-icon="mdi-magnify"
                          dense v-model="company" flat background-color="grey lighten-4"
                          label="Compagnie ..."></v-select></v-col>
                      <v-col cols="12" md="2">
                        <v-select outlined :items="productNameList" class="pt-5 pa-2" prepend-inner-icon="mdi-magnify"
                          dense v-model="product" flat background-color="grey lighten-4"
                          label="Produit"></v-select></v-col>
                      <v-col cols="12" md="2">
                        <v-select outlined :items="avenantList" class="pt-5 pa-2" prepend-inner-icon="mdi-magnify" dense
                          v-model="actionType" flat background-color="grey lighten-4"
                          label="Type d'avenant"></v-select></v-col>
                    </v-row>
                    <v-card-actions>
                      <v-btn class="red--text mr-2" outlined color="red" pill @click="cleanOnEnter">

                        Effacer
                      </v-btn>
                      <v-spacer></v-spacer>
                      <v-btn class="white--text mr-2" color="#0482fb" pill @click="onEnters">
                        <v-icon left>
                          mdi-magnify
                        </v-icon>
                        Appliquer la recherche
                      </v-btn>
                    </v-card-actions>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-container>
            <v-toolbar flat>
              <h4 class="text-h4 pageTitle ">Listing des emissions en attente reversements</h4>

              <v-divider class="mx-4" inset vertical></v-divider>
              <h4 class="text-h4 pageTitle ">{{ selectedReverse.length ? selectedReverse.length : 0 }} sélection</h4>
              <!-- <v-switch v-model="showAllFil" label="Afficher toutes les données" color="#0482fb"
                @change="showAllFillData" class="pt-5"></v-switch> -->
            </v-toolbar>
            <v-row>
              <v-btn color="#0482fb" dark class="mt-5 ml-5 mb-10" @click="applyRevesementModal()">
                Mise à jour des Données
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn color="#0482fb" dark class="mt-5 mr-5 mb-10" @click="applyBordereauModal()">
                Gestion de reverssement prime
              </v-btn>
            </v-row>

          </template>
          <template v-slot:item.name="{ item }">
            <td>
              {{ item.file.name }}
            </td>
          </template>
          <template v-slot:item.company="{ item }">
            <td>
              {{ item.company && item.company.name ? item.company.name : "" }}
            </td>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-menu elevation="0" right offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on" class="mr-10">
                  <v-icon color="success" size="30">mdi-forwardburger</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-tooltip bottom color="warning">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn class="ml-3" icon>
                      <v-icon size="20" @click="editItem(item)" v-bind="attrs" v-on="on"
                        color="warning">mdi-pencil-box-multiple-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>Modification du contrat sélectionné</span>
                </v-tooltip>
                <!-- <v-tooltip bottom color="success">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn class="ml-3" icon>
                      <v-icon size="20" color="success" v-bind="attrs" v-on="on"
                        @click="startNewContract(item)">mdi-checkbox-marked-circle-plus-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>Mise en place d'un nouveau contrat</span>
                </v-tooltip> -->
                <!-- <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn class="ml-3" icon>
                      <v-icon size="20" v-bind="attrs" v-on="on"
                        @click="getSinisterDeclaration(item)">mdi-ambulance</v-icon>
                    </v-btn>
                  </template>
                  <span>Déclaration d'un sinistre</span>
                </v-tooltip> -->

                <!-- <v-tooltip bottom color="error">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn class="ml-3" icon>
                      <v-icon @click="initCancelContract(item)" v-bind="attrs" v-on="on" size="20"
                        color="error">mdi-book-cancel-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>Annuler ce contrat</span>
                </v-tooltip> -->
              </v-list>
            </v-menu>
          </template>
        </v-data-table>
      </v-tab-item>
    </v-tabs-items>


    <!-- Cancel contrat -->
    <v-dialog transition="dialog-bottom-transition" max-width="800" overlay v-model="cancelDialog">
      <v-card style="border-top:10px solid red">
        <v-card-title>
          <span class="text-h5 mb-5 mt-5" style="color:#3A1C71;">Encaissement des dossiers sélectionnés</span>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <v-text-field outlined color="#0482fb" type="date" background-color="#cbf3f0"
                v-model="reversementData.primeRepaymentDate" label="Date encaissement prime"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field outlined color="#0482fb" type="date" background-color="#cbf3f0"
                v-model="reversementData.companyRepaymentDate" label="Date reversement compagnie"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field outlined color="#0482fb" background-color="#cbf3f0"
                v-model="reversementData.mailNumberReversement" label="Numéro courrier arrivée "></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-autocomplete outlined :items="itemsPayment" background-color="#cbf3f0" color="#0482fb"
                label="Mode de paiement" v-model="reversementData.paymentMethod"></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field outlined color="#0482fb" background-color="#cbf3f0" v-model="reversementData.checkNumber"
                label="Numéro chèque"></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-autocomplete outlined :items="itemsBank" background-color="#cbf3f0" color="#0482fb" label="Banque"
                v-model="reversementData.bank"></v-autocomplete>
            </v-col>
            <!-- <v-col cols="12" sm="6" md="4">
              <v-text-field outlined color="#0482fb" background-color="#cbf3f0"
                v-model="reversementData.mailNumberReversement" label="Banque"></v-text-field>
            </v-col> -->
          </v-row>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text @click="(cancelDialog = false), (cancelModal = {})">Annuler</v-btn>
          <v-btn color="error" class="white--text" @click="applyEncaissemnt()">Confirmer
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog transition="dialog-bottom-transition" max-width="800" overlay v-model="reversementModale">
      <v-card style="border-top:10px solid red">
        <v-card-title>
          <span class="text-h5 mb-5 mt-5" style="color:#3A1C71;">Reversement des dossiers sélectionnés</span>
        </v-card-title>
        <v-card-text>
          <v-row>
            <!-- <v-col cols="12" sm="6" md="4">
              <v-text-field outlined color="#0482fb" type="date" background-color="#cbf3f0"
                v-model="reversementData.primeRepaymentDate" label="Date encaissement prime"></v-text-field>
            </v-col> -->
            <v-col cols="12" sm="6" md="6">
              <v-text-field outlined color="#0482fb" type="date" background-color="#cbf3f0"
                v-model="reversementData.companyRepaymentDate" label="Date reversement compagnie"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field outlined color="#0482fb" background-color="#cbf3f0"
                v-model="reversementData.mailNumberReversement" label="Numéro courrier arrivée "></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-autocomplete outlined :items="itemsPayment" background-color="#cbf3f0" color="#0482fb"
                label="Mode de paiement" v-model="reversementData.paymentMethod"></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field outlined color="#0482fb" background-color="#cbf3f0" v-model="reversementData.checkNumber"
                label="Numéro chèque"></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-autocomplete outlined :items="itemsBank" background-color="#cbf3f0" color="#0482fb" label="Banque"
                v-model="reversementData.bank"></v-autocomplete>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text @click="(cancelDialog = false), (cancelModal = {})">Annuler</v-btn>
          <v-btn color="error" class="white--text" @click="applyRevesement()">Confirmer
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog transition="dialog-bottom-transition" max-width="1500" overlay v-model="bordereauModal">
      <v-card style="border-top:10px solid red">

        <v-card-text>











          <v-data-table v-model="selectedbordereau" class="pt-3" flat :loading="loading ? '#0482fb' : null"
            :headers="headersBordereau" :items="bordereauCommission" :items-per-page="5" sort-by="" item-key="_id"
            show-select>
            <template v-slot:top>
              <!-- <v-container fluid>
                <v-expansion-panels flat style="border: 1px solid #0482fb">
                  <v-expansion-panel class="elevation-0">
                    <v-expansion-panel-header>
                      Tri / Recherche ...
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row>
                        <v-col cols="12" md="3">
                          <v-text-field outlined color="#0482fb" label="Date encaissement début" class="pt-5 pa-2"
                            prepend-inner-icon="mdi-magnify" v-model="primeRepaymentDateStart" type="date" dense flat
                            background-color="grey lighten-4"></v-text-field></v-col>
                        <v-col cols="12" md="3">
                          <v-text-field outlined color="#0482fb" label="Date encaissement fin" class="pt-5 pa-2"
                            prepend-inner-icon="mdi-magnify" v-model="primeRepaymentDateEnd" type="date" dense flat
                            background-color="grey lighten-4"></v-text-field></v-col>

                        <v-col cols="12" md="2">
                          <v-autocomplete outlined :items="userFile" class="pt-5 pa-2 mx-2"
                            prepend-inner-icon="mdi-magnify" v-model="fileName" dense flat
                            background-color="grey lighten-4" label="Nom / Raison Sociale ...">
                          </v-autocomplete>
                        </v-col>
                        <v-col cols="12" md="2">
                          <v-text-field outlined color="#0482fb" label="Numéro Police ..." class="pt-5 pa-2"
                            v-model="policeNumber" prepend-inner-icon="mdi-magnify" dense flat
                            background-color="grey lighten-4"></v-text-field></v-col>
                        <v-col cols="12" md="2">
                          <v-text-field outlined color="#0482fb" label="Numéro Avenant ..." class="pt-5 pa-2"
                            prepend-inner-icon="mdi-magnify" dense v-model="plugged" flat
                            background-color="grey lighten-4"></v-text-field></v-col>
                        <v-col cols="12" md="2">
                          <v-text-field outlined color="#0482fb" label="Numéro Emission ..." class="pt-5 pa-2"
                            prepend-inner-icon="mdi-magnify" dense v-model="emissionNumber" flat
                            background-color="grey lighten-4"></v-text-field></v-col>
                        <v-col cols="12" md="2">

                          <v-text-field outlined color="#0482fb" label="Numéro Quittance ..." class="pt-5 pa-2"
                            prepend-inner-icon="mdi-magnify" dense v-model="receiptNumber" flat
                            background-color="grey lighten-4"></v-text-field></v-col>
                        <v-col cols="12" md="2">
                          <v-text-field outlined color="#0482fb" label="Numéro Client ..." class="pt-5 pa-2"
                            prepend-inner-icon="mdi-magnify" dense v-model="customerNumber" flat
                            background-color="grey lighten-4"></v-text-field></v-col>
                        <v-col cols="12" md="2">
                          <v-select outlined :items="companyNameList" class="pt-5 pa-2" prepend-inner-icon="mdi-magnify"
                            dense v-model="company" flat background-color="grey lighten-4"
                            label="Compagnie ..."></v-select></v-col>
                        <v-col cols="12" md="2">
                          <v-select outlined :items="productNameList" class="pt-5 pa-2" prepend-inner-icon="mdi-magnify"
                            dense v-model="product" flat background-color="grey lighten-4"
                            label="Produit"></v-select></v-col>
                        <v-col cols="12" md="2">
                          <v-select outlined :items="avenantList" class="pt-5 pa-2" prepend-inner-icon="mdi-magnify" dense
                            v-model="actionType" flat background-color="grey lighten-4"
                            label="Type d'avenant"></v-select></v-col>
                      </v-row>
                      <v-card-actions>
                        <v-btn class="red--text mr-2" outlined color="red" pill @click="cleanOnEnter">

                          Effacer
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn class="white--text mr-2" color="#0482fb" pill @click="onEnters">
                          <v-icon left>
                            mdi-magnify
                          </v-icon>
                          Appliquer la recherche
                        </v-btn>
                      </v-card-actions>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-container> -->
              <v-toolbar flat>
                <h4 class="text-h4 pageTitle ">Envoi de dossier attente d'encaissement commission</h4>

                <v-divider class="mx-4" inset vertical></v-divider>
                <h4 class="text-h4 pageTitle ">{{ selectedbordereau.length ? selectedbordereau.length : 0 }} sélections
                </h4>
                <!-- <v-switch v-model="showAllFil" label="Afficher toutes les données" color="#0482fb"
                @change="showAllFillData" class="pt-5"></v-switch> -->
              </v-toolbar>
              <v-row>
                <v-btn color="#0482fb" dark class="mt-5 ml-5 mb-10" @click="directApplyRevesementModal()">
                  Envoie direct
                </v-btn>
                <v-spacer></v-spacer>
                <v-col cols="12" md="2">
                  <v-autocomplete outlined class="mt-2 mr-5 mb-10" @change="applyBordereauModal()" filled dense flat
                    :items="companyNameList" background-color="#cbf3f0" color="#0482fb" label="Compagnie"
                    v-model="compagnieMethodeValue"></v-autocomplete>
                </v-col>
                <v-col cols="12" md="2">
                  <v-autocomplete outlined class="mt-2 mr-5 mb-10" @change="applyBordereauModal()" filled dense flat
                    :items="itemsPayment" background-color="#cbf3f0" color="#0482fb" label="Mode de paiement"
                    v-model="paymentMethodValue"></v-autocomplete>
                </v-col>
                <v-btn color="#0482fb" dark class="mt-5 mr-5 mb-10" @click="printApplyBordereauModal()">
                  Imprimer bordereau
                </v-btn>
              </v-row>

            </template>
            <template v-slot:item.name="{ item }">
              <td>
                {{ item.file.name }}
              </td>
            </template>
            <template v-slot:item.company="{ item }">
              <td>
                {{ item.company && item.company.name ? item.company.name : "" }}
              </td>
            </template>
          </v-data-table>










































        </v-card-text>

      </v-card>
    </v-dialog>
    <!--  Déclaration sinistre-->
    <template>
      <div>
        <v-row justify="center">
          <v-dialog v-model="sinisterDialog" overlay transition="dialog-bottom-transition" scrollable max-width="1000px">
            <v-form ref="form" lazy-validation>
              <v-card style="border-top:10px solid #0482fb " tile>
                <v-card-text>
                  <h2 class="pt-8 pl-3">Prise de déclaration sinsitre</h2>
                  <v-container fluid>
                    <v-row align="center">
                      <!-- <v-col cols="12" sm="3">
                      <v-text-field outlined  
            color="#0482fb"
                        v-model="sinisterAskNumber"
                        label="Numéro sinistre DAYO"
                      ></v-text-field>
                    </v-col> -->
                      <v-col cols="12" sm="3">
                        <v-text-field outlined color="#0482fb" v-model="declarationModal.sinisterCompanyNumber"
                          label="Numéro sinistre compagnie"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="3">
                        <v-text-field outlined color="#0482fb" v-model="declarationModal.dateOfOccurrence" type="date"
                          :rules="[
                            (v) => !!v || 'Date de survenance non remplie',
                          ]" label="Date  survenance"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="3">
                        <v-text-field outlined color="#0482fb" v-model="declarationModal.declarationDate" type="date"
                          label="Date déclaration"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="3">
                        <v-text-field outlined color="#0482fb" v-model="declarationModal.companyDispatchDate" type="date"
                          label="Date envoi compagnie"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="3">
                        <v-text-field outlined color="#0482fb" v-model="declarationModal.driverName"
                          label="Nom conducteur"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="3">
                        <v-text-field outlined color="#0482fb" v-model="declarationModal.conductiveContact"
                          label="Contact conducteur"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="3">
                        <v-text-field outlined color="#0482fb" v-model="declarationModal.registrationValidationDate"
                          type="date" label="Date retour compagnie"></v-text-field>
                      </v-col>

                      <v-col cols="12" md="12">
                        <v-textarea outlined v-model="declarationModal.circumstance" name="input-7-4"
                          label="Circonstance du sinistre" value=""></v-textarea>
                      </v-col>
                      <v-col cols="12" sm="3">
                        <v-text-field outlined color="#0482fb" disabled v-model="declarationModal.PSAP" type="number"
                          label="PSAP"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="3">
                        <v-text-field outlined color="#0482fb" v-model="declarationModal.disasterObject"
                          label="Objet sinistré"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="3">
                        <v-text-field outlined color="#0482fb" v-model="declarationModal.materialDamageInsured"
                          label="Dommages matériels assuré"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="3">
                        <v-text-field outlined color="#0482fb" v-model="declarationModal.insuredBodilyInjury"
                          label="Dommages coporels assuré"></v-text-field>
                      </v-col>

                      <v-col cols="12" md="12">
                        <v-textarea outlined v-model="declarationModal.observation" name="input-7-4"
                          label="Renseignements Tiers" value=""></v-textarea>
                      </v-col>
                    </v-row>
                  </v-container>
                  <v-row justify="end">
                    <v-btn tile color="error" text @click="sinisterDialog = false">
                      Fermer
                    </v-btn>
                    <v-btn tile color="success" class="ml-10" @click="cashIn">
                      Enregistrer
                    </v-btn>
                  </v-row>
                </v-card-text>

                <div style="flex: 1 1 auto"></div>
              </v-card>
            </v-form>
          </v-dialog>
        </v-row>
      </div>
    </template>
    <!-- factue contrat -->
    <v-dialog transition="dialog-bottom-transition" max-width="500" overlay v-model="factureDialog">
      <v-card style="border-top:10px solid red">
        <v-card-title>Imprimer une facture</v-card-title>
        <v-card-text>
          <div class=" pt-6 ">

            <v-autocomplete outlined :items="['DOIT', 'AVOIR']" color="#0482fb" class=""
              prepend-inner-icon="mdi-nature-people" v-model="invoiceInformation.invoiceNature" dense flat
              background-color="grey lighten-4" label="Nature de facture">
            </v-autocomplete>

          </div>
        </v-card-text>
        <v-card-actions class="justify-end pb-6">
          <!-- <v-btn text @click="(cancelDialog = false), (cancelModal = {})">Annuler</v-btn> -->
          <v-btn color="success" class="white--text" block @click="printSimpleFacture('simple')">Imprimer Facture
          </v-btn>
          <!-- <v-spacer></v-spacer> -->
          <!-- <v-btn color="success" class="white--text" @click="printSimpleFacture('PROFORMA')">Imprimé Facture Proforma
          </v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--  Pop up des Contrat-->
    <template>
      <div>
        <v-row justify="center">
          <v-dialog v-model="contractDialog" overlay transition="dialog-bottom-transition" max-width="1000px">
            <save-dialog v-if="contractDialog" @success="successSaveContract" @closeDialog="closeContract"
              :modal="contractModal" />
          </v-dialog>
        </v-row>
      </div>
      <v-dialog v-model="Shodialog" max-width="490">
        <v-card class="pt-5" style="text-align:center,">
          <v-card-text>{{ testAlert }} </v-card-text>
        </v-card>
      </v-dialog>
    </template>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { defaultMethods, messages } from "@/utils/data";
import { addFile, updateFile } from "@/api/admin";
import {
  cancelContract,
  createDeclaration,
  updateContract,
  addContract,

} from "@/api/user.js";
import SaveDialog from "../components/contrat/saveDialog.vue";
export default {
  name: "production",
  components: { SaveDialog },
  data: () => ({
    perssonel: [],

    items: ["NSIA", "SANLAM", "SAHAM", "ATLANTIQUE ASSURANCE"],
    natureprospect: ["Physics", "Entreprise"],
    Shodialog: false,
    contractDialog: false,
    tab: null,
    selectedReverse: {},
    selectedbordereau: {},
    singleSelect: true,
    paymentMethodValue: "",
    invoiceInformation: {
      invoiceNature: "",
      invoiceContractId: "",
    },
    selected: {},
    factureDialog: false,
    reversementModale: false,
    reversementData: {},
    showReversementBouton: true,
    headers: [
      {
        text: "Actions",
        width: "100px",
        align: "start",
        value: "actions",
      },
      {
        text: "Date Encaissement prime",
        width: "200px",
        align: "start",
        sortable: false,
        value: "primeRepaymentDate",
      },
      {
        text: "Date Reversement prime",
        width: "200px",
        align: "start",
        sortable: false,
        value: "companyRepaymentDate",
      },
      {
        text: "Nom / Raison Sociale",
        width: "200px",
        // align: "start",
        value: "name",
      },
      { text: "Branche", width: "200px", value: "product" },
      { text: "Catégorie", width: "200px", value: "category" },
      { text: "Compagnie", width: "200px", value: "company" },
      { text: "Type Avenant", width: "200px", value: "actionType" },
      { text: "Numéro police", width: "200px", value: "policeNumber" },
      { text: "Numéro avenant", width: "200px", value: "plugged" },
      { text: "Date émission", width: "200px", value: "createdAtFr" },
      { text: "Effet", width: "200px", value: "effectDateFr" },
      { text: "Echeance", width: "200px", value: "dueDateFr" },
      { text: "Prime Nette", width: "200px", value: "netPrime" },
      { text: "Prime TTC", width: "200px", value: "totalPrime" },
    ],
    headersBordereau: [
      {
        text: "N° facture déf",
        width: "150px",
        align: "start",
        sortable: false,
        value: "paymentInvoiceNumber",
      },
      { text: "Prime TTC", width: "200px", value: "totalPrime" },
      { text: "Numéro police", width: "200px", value: "policeNumber" },

      {
        text: "Date Encaissement prime",
        width: "200px",
        align: "start",
        sortable: false,
        value: "primeRepaymentDate",
      },
      {
        text: "Date Reversement prime",
        width: "200px",
        align: "start",
        sortable: false,
        value: "companyRepaymentDate",
      },
      {
        text: "Nom / Raison Sociale",
        width: "200px",
        // align: "start",
        value: "name",
      },
      { text: "Branche", width: "200px", value: "product" },
      { text: "Catégorie", width: "200px", value: "category" },
      { text: "Compagnie", width: "200px", value: "company" },
      { text: "Type Avenant", width: "200px", value: "actionType" },
      { text: "Numéro avenant", width: "200px", value: "plugged" },
      { text: "Date émission", width: "200px", value: "createdAtFr" },
      { text: "Effet", width: "200px", value: "effectDateFr" },
      { text: "Echeance", width: "200px", value: "dueDateFr" },
      { text: "Prime Nette", width: "200px", value: "netPrime" },
    ],
    contrat: [
      {
        name: "gras savoye",
        company: "NSIA",
        endorsementType: "Affaire nouvelle",
        policeNumber: "2021445588",
        endorsementNumber: "2020114455",
        plugged: "Automobile",
        effect: "22/08/2022",
        dueDate: "31/12/2022",
        primeTTC: "1500000",
      },
    ],
    currentProduct: null,
    itemsPayment: ["Espèces", "Chèque", "Virement", "Avoir"],
    itemsBank: [
      "BANQUE INTERNATIONALE POUR L’INDUSTRIE ET LE COMMERCE (BIIC)",
      "BANK Of AFRICA (BOA)",
      "ORABANK BENIN (OBB)",
      "ECOBANK BENIN (EBB)",
      "NSIA BANQUE",
      "SOCIETE GENERALE du BENIN (SGB)",
      "BANQUE SAHELO-SAHARIENNE POUR L’INVESTISSEMENTEMENT ET LE COMMERCE (BSIC-BENIN)",
      "BANQUE ATLANTIQUE AU BENIN (BAB)",
      "BGFIBANK BENIN",
      "UNITED BANK FOR AFRICA (UBA)",
      "CCEI BANK BENIN Afriland First Group",
      "CBAO BENIN Groupe Attijariwafa Bank",
      "CORIS BANK INTERNATIONAL (CBI)",
      "SOCIÉTÉ NIGÉRIENNE DE BANQUE (SONIBANK)",
      "TRESOR PUBLIC",
     "BANGE BANK BENIN"
    ],
    avenantList: [
      "Affaire Nouvelle",
      "Renouvellement",
      "Incorporation",
      "Retrait",
      "Suspension",
      "Remise en vigeur",
      "Precision",
      "Modification",
      "Resiliation",
      "Régularisation",
      "Prérogation",
      "Changement d'immatriculation",
    ],
    proposedProductNameList: [],
    companyNameList: [],
    productNameList: [],
    coinsuranceCompanyNameList: [],
    CommercialNameList: [],
    prospectsNameList: [],
    bordereauModal: false,
    Contract: "",
    contractModal: {
      accessory100: 0,
      accessory50: 0,
    },
    incorporationModal: {},
    regulationClauseModal: {
      reminderDate: "",
      companyRequestDate: "",
      companyReturnDate: "",
      customerRequestDate: "",
      customerReturnDate: "",
    },
    pbClauseModal: {
      reminderDate: "",
      companyRequestDate: "",
      companyReturnDate: "",
      customerRequestDate: "",
      customerReturnDate: "",
    },

    coinsuranceModal: [
      {
        shareRate: 0,
        company: "",
        observation: "",
      },
    ],
    customerReturnDialog: false,
    categorie: [],
    companyReturnDialog: false,
    contratsearchData: "",
    companyReturnModal: {},
    compagnieMethodeValue: "",
    fileName: "",
    product: "",
    policeNumber: "",
    plugged: "",
    company: "",
    prospectdata: [],
    editedIndex: -1,
    fileModal: {
      name: "",
      nature: "",
      phone: "",
      activity: "",
      email: "",
      birthday: "",
      location: "",
      prospects: [],
    },
    defaultItem: {
      nom: "",
      Nature: "",
      Contact: "",
      Activité: "",
      Mail: "",
      Anniverssaire: "",
      Localisation: "",
    },
    email: "",
    name: "",
    contact: "",
    birthday: "",
    declarationModal: [],
    dialogDelete: false,
    cancelDialog: false,
    sinisterDialog: false,
    emailRules: [
      (v) => !!v || "E-mail is ",
      (v) => /.+@.+/.test(v) || "E-mail must be valid",
    ],
    loader: false,
    loading: false,
    fileDialog: false,
  }),

  mounted() {
    this.initQuotingRequest();
    // this.$refs.calendar.checkChange();
  },
  computed: {
    ...mapGetters([
      "Files",
      "QuotingRequests",
      "ContractsList",
      "ContratOtherList",
      "Products",
      "Companies",
      "bordereauCommission"
    ]),
    formTitle() {
      return this.editedIndex === -1
        ? "Ajouter Dossier Production"
        : "Modifier Dossier Production ";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    contractModal() { },
    Companies() {
      this.companyNameList = defaultMethods.getNameList(this.Companies.docs);
    },
    Products() {
      this.productNameList = defaultMethods.getNameList(this.Products.docs);
    },
    Files() {
      this.userFile = defaultMethods.getNameList(this.Files.docs);
    },
    Contract() {
      if (this.Contract) {
        this.contractModal = this.Contract;
        this.contractModal.company = defaultMethods.getItemName(
          this.Companies.docs,
          this.contractModal.company
        );
        this.contractModal.commercial = defaultMethods.getItemName(
          this.Users.docs,
          this.contractModal.commercial
        );

        // this.contractModal.dueDate =
        //   this.contractModal.dueDate
        // this.contractModal.effectDate =
        //   this.contractModal.effectDate
        // this.contractModal.paymentDate =
        //   this.contractModal.paymentDate

        if (this.Contract.otherInfo) {
          // clause regulation
          if (this.Contract.otherInfo.regulationClause) {
            this.regulationClauseModal = this.Contract.otherInfo.regulationClause;
          }

          // pb clause
          // clause regulation
          if (this.Contract.otherInfo.pbClause) {
            this.pbClauseModal = this.Contract.otherInfo.pbClause;
          }

          // coinsurance
          if (this.Contract.otherInfo.coinsurance) {
            this.coinsuranceModal = this.Contract.otherInfo.coinsurance;
            for (let i = 0; i < this.coinsuranceModal.length; i++) {
              this.coinsuranceModal[i].company = defaultMethods.getItemName(
                this.Companies.docs,
                this.coinsuranceModal[i].company
              );
            }
          }
        }
      } else {
        this.contractModal = {
          accessory100: 0,
          accessory50: 0,
        };
      }
    },
    selected() {
      localStorage.setItem("encaisementSelect", JSON.stringify(this.selected));
      // alert(JSON.stringify())
    },
    selectedReverse() {
      localStorage.setItem("reversementSelect", JSON.stringify(this.selectedReverse));
      // alert(JSON.stringify())
    },
    selectedbordereau() {
      localStorage.setItem("bordereauSelect", JSON.stringify(this.selectedbordereau));
      // alert(JSON.stringify())
    }
  },

  methods: {
    ...mapActions([
      "getQuotingRequests",
      "getContracts",
      "postSearchContratTrue",
      "getProducts",
      "getCompanies",
      "getFiles",
      "getContractsOther",
      "postSearchContratTrueSecond",
      "getDocFactureEncaissement",
      "getContractsBordereau",
      "printOfferDoc"
    ]),
    handleClickFacture(item) {
      // console.log(item)
      // alert(item.invoiceNature)
      this.invoiceInformation.invoiceContractId = item._id
      this.invoiceInformation.invoiceNature = item.invoiceNature
      this.factureDialog = true
    },
    async printSimpleFacture(item) {
      // alert(item)
      const schema = {
        invoiceNature: this.invoiceInformation.invoiceNature,
        type: item
      }
      await this.getDocFactureEncaissement(
        { schema, id: this.invoiceInformation.invoiceContractId, });
      defaultMethods.dispatchSuccess(
        this.$store,
        messages.canceledSuccessfully("Ce contrat")
      );
    },
    closeForm() {
      this.fileModal = {
        birthday: "",
        prospects: [],
      };
      this.fileDialog = false;
      this.dialogDelete = false;

      this.editedIndex = -1;
    },
    showAllFillData() {
      this.initQuotingRequest();
      //alert(this.showAllFil);
    },
    closeCancel() {
      this.cancelModal = {};
      this.cancelDialog = false;
    },
    async saveCancelContract() {
      this.loading = true;
      try {
        // add

        await cancelContract({ id: this.contractModal._id });
        defaultMethods.dispatchSuccess(
          this.$store,
          messages.canceledSuccessfully("Ce contrat")
        );
        this.closeCancel();
        this.initQuotingRequest();
      } catch (error) {
        alert(error);
        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
    },
    startNewContract(item) {
      //alert(this.Contract.productName)

      this.contractModal = {
        accessory100: 0,
        accessory50: 0,
      };
      switch (this.Contract.productName) {
        case "ASSURANCE CAUTION":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;
        case "ASSURANCE CREDIT":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;
        case "ASSURANCE CREDIT BAIL":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;
        case "MALADIE":
          {
            this.categorie = ["MALADIE", "GESTION CONFIEE"];
          }
          break;
        case "ASSURANCES TRANSPORTS":
          {
            this.categorie = ["TERRESTRE", "MARITIME", "AERIEN", "FERROVIAIRE"];
          }
          break;
        case "AUTOMOBILE":
          {
            this.categorie = ["FLOTTE AUTO", "MONO AUTO", "FLOTTE MOTO", "MONO MOTO "];
          }
          break;


        case "BRIS DE MACHINE":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;
        case "FAUX PAIEMENTS":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;
        case "GLOBALE DE BANQUE":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;


        case "GLOBALE DOMMAGES":
          {
            this.categorie = ["INCENDIE"];
          }
          break;
        case "INDEMNITE DE FIN DE CARRIERE":
          {
            this.categorie = ["ASSURANCES DE PERSONNES"];
          }
          break;
        case "INDIVIDUELLE ACCIDENTS CORPORELS":
          {
            this.categorie = ["ASSURANCES DE PERSONNES"];
          }
          break;


        case "MULTIRISQUE HABITATION":
          {
            this.categorie = [
              "INCENDIE"
            ];
          }
          break;
        case "MULTIRISQUE PROFESSIONNELLE":
          {
            this.categorie = [
              "INCENDIE"
            ];
          }
          break;





        case "PREVOYANCE DECES":
          {
            this.categorie = [
              "ASSURANCES DE PERSONNES"
            ];
          }
          break;
        case "RC CHEF D'ENTREPRISE":
          {
            this.categorie = ["RESPONSABILITE"];
          }
          break;
        case "RC CHEF DE FAMILLE":
          {
            this.categorie = ["RESPONSABILITE"];
          }
          break;
        case "RESPONSABILITE CIVILE DECENNALE":
          {
            this.categorie = ["RESPONSABILITE"];
          }
          break;
        case "RC EXPLOITATION":
          {
            this.categorie = ["RESPONSABILITE"];
          }
          break;
        case "PREVOYANCE PLUS":
          {
            this.categorie = ["ASSURANCES DE PERSONNES"];
          }
          break;
        case "RC PROFESSIONNELLE":
          {
            this.categorie = ["RESPONSABILITE"];
          }
          break;
        case "RC EVENEMENTS SPORTIFS":
          {
            this.categorie = ["RESPONSABILITE"];
          }
          break;
        case "RESPONSABILITE CIVILE":
          {
            this.categorie = ["RESPONSABILITE"];
          }
          break;


        case "TOUS RISQUES MONTAGE/ESSAI":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;
        case "VOL ":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;



        case "RC SCOLAIRE":
          {
            this.categorie = ["RESPONSABILITE"];
          }
          break;
        case "RETRAITE COMPLEMENTAIRE":
          {
            this.categorie = ["ASSURANCE DE PERSONNES"];
          }
          break;

        case "TOUS DOMMAGES SAUF":
          {
            this.categorie = ["INCENDIE"];
          }
          break;
        case "TOUS RISQUES CHANTIER":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;
        case "ASSISTANCE AU VOYAGE":
          {
            this.categorie = ["ASSURANCE DE PERSONNES"];
          }
          break;



        case "VIOLENCE POLITIQUE":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;
        case "RC TRANSPORTEUR":
          {
            this.categorie = ["RESPONSABILITE"];
          }
          break;
        case "TRANSPORT DE FONDS":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;
        case "DJIGUIYA":
          {
            this.categorie = ["MALADIE"];
          }
          break;
        case "EVACUATION SANITAIRE":
          {
            this.categorie = ["MALADIE"];
          }
          break;


        case "ASSURANCE MOYEN DE PAIEMENT":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;






        case "AUTOFINANCEMENT":
          {
            this.categorie = ["HONORAIRES PAR BENEFICIAIRE", "HONORAIRES MONTANT FIXE", "HONORAIRES MONTANT NOMINAL", "HONORAIRES CARTE SANTE", "HONORAIRES DE REGULARISATION"];
          }
          break;
        case "INCENDIE SIMPLE":
          {
            this.categorie = ["INCENDIE"];
          }
          break;
        case "MULTIRISQUE INDUSTRIELLE":
          {
            this.categorie = ["INCENDIE"];
          }
          break;
        case "AUTOMOBILE TPV":
          {
            this.categorie = ["FLOTTE AUTO", "MONO AUTO"];
          }
          break;
        case "ASSISTANCE":
          {
            this.categorie = ["ASSURANCES DE PERSONNES"];
          }
          break;
        case "MOGOBAYA":
          {
            this.categorie = ["MALADIE"];
          }
          break;
        case "IKENEYA":
          {
            this.categorie = ["MALADIE"];
          }
          break;
        case "HONORAIRES BONUS COMMISSION":
          {
            this.categorie = ["BONUS /MALUS"];
          }
          break;
        case "TEMPORAIRE DECES":
          {
            this.categorie = ["ASSURANCES DE PERSONNES"];
          }
          break;
        case "WGARAGE":
          {
            this.categorie = ["FLOTTE AUTO"];
          }
          break;
      }
      this.seedCtr(item);
      this.contractDialog = true;

      this.contractModal.isNew = true;
    },
    seedCtr(item) {
      this.contractModal = Object.assign({}, item);
      this.editItemFormat(item);
      this.contractModal.isNew = true;
      if (this.Companies && this.Companies.docs) {
        this.contractModal.company = this.contractModal.company.name;
        // alert(this.Contract.productName)
      }
    },
    initCancelContract(item) {
      this.contractModal = Object.assign({}, item);
      this.editItemFormat(item);
      this.cancelDialog = true;
    },
    async cleanOnEnter() {
      this.loading = true;
      this.encaissementPeriodStartDate = ""
      this.encaissementPeriodEndDate = ""
      this.encaissementFileName = ""
      this.encaissementPoliceNumber = ""
      this.encaissementPlugged = ""
      this.encaissementEmissionNumber = ""
      this.encaissementReceiptNumber = ""
      this.encaissementCustomerNumber = ""
      this.encaissementCompany = ""
      this.encaissementProduct = ""
      this.encaissementActionType = ""

      this.primeRepaymentDateStart = ""
      this.primeRepaymentDateEnd = ""
      this.fileName = ""
      this.policeNumber = ""
      this.plugged = ""
      this.emissionNumber = ""
      this.receiptNumber = ""
      this.customerNumber = ""
      this.company = ""
      this.product = ""
      this.actionType = ""


      await this.getContracts({
        contractEstablished: true,
        withQuoting: false,
        currentYear: true,
        primeRepaymentDateExist: "false"
      });
      this.selected = JSON.parse(localStorage.getItem("encaisementSelect"))
      await this.getContractsOther({
        contractEstablished: true,
        withQuoting: false,
        currentYear: true,
        primeRepaymentDateExist: "true",
        companyRepaymentDateExist: "false"
      });
      this.selectedReverse = JSON.parse(localStorage.getItem("reversementSelect"))

      this.loading = false;
    },
    async initQuotingRequest() {
      this.loading = true;
      try {
        this.singleSelect = {};
        this.selected = {};
        this.selectedReverse = {};
        this.ContractsList = {}
        await this.getContracts({
          contractEstablished: true,
          withQuoting: false,
          currentYear: true,
          primeRepaymentDateExist: "false"
        });
        this.selected = JSON.parse(localStorage.getItem("encaisementSelect"))
        await this.getContractsOther({
          contractEstablished: true,
          withQuoting: false,
          currentYear: true,
          primeRepaymentDateExist: "true",
          companyRepaymentDateExist: "false"
        });
        this.selectedReverse = JSON.parse(localStorage.getItem("reversementSelect"))

        await this.getFiles({ withoutPeriod: true });
        await this.getProducts({ name: this.searchData });
        await this.getCompanies();
      } catch (error) {
        console.log(error);
        defaultMethods.dispatchError(
          this.$store,
          messages.failedToLoad("les contrats")
        );
      }
      this.loading = false;
    },
    async makeSearchContractReversement() {

      this.loading = true;
      try {
        await this.postSearchContratTrueSecond({
          fileName: defaultMethods.getItemId(this.Files.docs, this.fileName),
          product: this.product,
          policeNumber: this.policeNumber,
          plugged: this.plugged,
          company: this.company,
          contractEstablished: true,
          periodStartDate: "",
          periodEndDate: "",
          primeRepaymentDateExist: "true",
          companyRepaymentDateExist: "false",
          primeRepaymentStartDate: this.primeRepaymentDateStart,
          primeRepaymentEndDate: this.primeRepaymentDateEnd,
          //withQuoting: true,
          emissionNumber: this.emissionNumber,
          customerNumber: this.customerNumber,
          receiptNumber: this.receiptNumber,
          actionType: this.actionType,
          // withoutPeriod: true,
          effectStartDate: this.effectStartDate,
          effectEndDate: this.effectEndDate,
          dueStartDate: this.dueStartDate,
          dueEndDate: this.dueEndDate,
          avenantList: this.avenantList,
        });
      } catch (error) {
        console.log(error);
        defaultMethods.dispatchError(
          this.$store,
          messages.failedToLoad("les contrats")
        );
      }
      this.loading = false;
    },
    async makeSearchContract() {
      this.loading = true;
      try {
        await this.postSearchContratTrue({
          fileName: defaultMethods.getItemId(this.Files.docs, this.encaissementFileName),
          product: this.encaissementProduct,
          policeNumber: this.encaissementPoliceNumber,
          plugged: this.encaissementPlugged,
          company: this.encaissementCompany,
          contractEstablished: true,
          //withQuoting: true,
          emissionNumber: this.encaissementEmissionNumber,
          customerNumber: this.encaissementCustomerNumber,
          receiptNumber: this.encaissementReceiptNumber,
          actionType: this.encaissementActionType,
          withoutPeriod: this.showAllFil,

          periodStartDate: this.encaissementPeriodStartDate,
          periodEndDate: this.encaissementPeriodEndDate,


          effectStartDate: this.effectStartDate,
          effectEndDate: this.effectEndDate,
          dueStartDate: this.dueStartDate,
          dueEndDate: this.dueEndDate,
          avenantList: this.avenantList,
        });
      } catch (error) {
        console.log(error);
        defaultMethods.dispatchError(
          this.$store,
          messages.failedToLoad("les contrats")
        );
      }
      this.loading = false;
    },
    onEnter: function () {
      if (
        this.encaissementPeriodStartDate == undefined &&
        this.encaissementPeriodEndDate != undefined
      ) {
        this.testAlert = "";
        this.testAlert =
          "Date création début requis pour la période de recherche";
        this.Shodialog = true;
      } else if (
        this.encaissementPeriodEndDate == undefined &&
        this.encaissementPeriodStartDate != undefined
      ) {
        this.testAlert = "";
        this.testAlert =
          "Date création fin requise pour la période de recherche";
        this.Shodialog = true;
      } else if (
        this.encaissementPeriodStartDate == undefined &&
        this.encaissementPeriodEndDate == undefined
      ) {
        this.testAlert = "";
        this.testAlert = "Veuillez définir la période de recherche";
        this.Shodialog = true;
      } else {
        this.makeSearchContract();
      }
    },
    onEnters: function () {
      if (
        this.primeRepaymentDateStart == undefined &&
        this.primeRepaymentDateEnd != undefined
      ) {
        this.testAlert = "";
        this.testAlert =
          "Date création début requis pour la période de recherche";
        this.Shodialog = true;
      } else if (
        this.primeRepaymentDateEnd == undefined &&
        this.primeRepaymentDateStart != undefined
      ) {
        this.testAlert = "";
        this.testAlert =
          "Date création fin requise pour la période de recherche";
        this.Shodialog = true;
      } else if (
        this.primeRepaymentDateStart == undefined &&
        this.primeRepaymentDateEnd == undefined
      ) {
        this.testAlert = "";
        this.testAlert = "Veuillez définir la période de recherche";
        this.Shodialog = true;
      } else {
        this.makeSearchContractReversement();
      }
    },
    getSinisterDeclaration(item) {
      this.declarationModal.contentID = item._id;

      this.sinisterDialog = true;
    },
    async cashIn() {
      this.$refs.form.validate();

      if (this.$refs.form.validate()) {
        this.saveDeclaration();
      }
    },
    async saveDeclaration() {
      this.loading = true;

      try {
        const schema = {
          sinisterCompanyNumber: this.declarationModal.sinisterCompanyNumber,
          circumstance: this.declarationModal.circumstance,
          dateOfOccurrence: this.declarationModal.dateOfOccurrence,
          declarationDate: this.declarationModal.declarationDate,
          companyDispatchDate: this.declarationModal.companyDispatchDate,
          driverName: this.declarationModal.driverName,
          conductiveContact: this.declarationModal.conductiveContact,
          registrationValidationDate: this.declarationModal
            .registrationValidationDate,
          PSAP: this.declarationModal.PSAP,
          disasterObject: this.declarationModal.disasterObject,
          insuredBodilyInjury: this.declarationModal.insuredBodilyInjury,
          materialDamageInsured: this.declarationModal.materialDamageInsured,

          observation: this.declarationModal.observation,
          // file: this.File._id,
        };
        if (this.declarationModal.dateOfOccurrence != "") {
          // add
          await createDeclaration({
            schema,
            id: this.declarationModal.contentID,
          });
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.createdSuccessfully("Declaration")
          );
          this.closeDeclaration();
          this.initQuotingRequest();
        } else {
          defaultMethods.dispatchError("Date survenance requis");
        }
      } catch (error) {
        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
    },
    closeDeclaration() {
      this.declarationModal = {};
      this.sinisterDialog = false;
      // this.currentProduct = null;
    },
    async saveProspect() {
      this.loading = true;
      try {
        if (this.fileModal._id) {
          // update
          await updateFile({
            schema: {
              name: this.fileModal.name,
              prospects: this.fileModal.prospects,
              phone: this.fileModal.phone,
              email: this.fileModal.email,
              nature: this.fileModal.nature,
              location: this.fileModal.location,
              description: this.fileModal.description,
              activityField: this.fileModal.activityField,
              birthday: this.fileModal.birthday,
              // proposedProducts: this.fileModal.proposedProducts,
            },
            id: this.fileModal._id,
          });
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.updatedSuccessfully("Dossier")
          );
          this.closeForm();
          this.initQuotingRequest();
        } else {
          // add
          await addFile(this.fileModal);
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.createdSuccessfully("Dossier")
          );
          this.closeForm();
          this.initQuotingRequest();
        }
      } catch (error) {
        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
    },
    all() {
      this.panel = [...Array(this.items.length).keys()].map((k, i) => i);
    },
    addPersonnel() {
      this.fileModal.prospects.push({
        fullName: this.name,
        email: this.email,
        contact: this.contact,
        birthday: this.birthday,
      });

      this.initPersonnelForm();
    },
    async saveContract() {
      this.loading = true;
      try {
        const schema = {
          policeNumber: this.contractModal.policeNumber,
          plugged: this.contractModal.plugged,
          actionType: this.contractModal.actionType,
          category: this.contractModal.category,
          company: defaultMethods.getItemId(
            this.Companies.docs,
            this.contractModal.company
          ),
          // commercial: defaultMethods.getItemId(
          //   this.Users.docs,
          //   this.contractModal.commercial
          // ),
          effectDate: this.contractModal.effectDate,
          dueDate: this.contractModal.dueDate,
          // paymentDate: this.contractModal.paymentDate,
          netPrime: this.contractModal.netPrime,
          // commission: this.contractModal.commission,
          totalPrime: this.contractModal.totalPrime,
          cdeaoPrime: this.contractModal.cdeaoPrime,
          observation: this.contractModal.observation,
          accessory100: this.contractModal.accessory100,
          accessory50: this.contractModal.accessory100 / 2,
        };

        if (!this.contractModal.isNew) {
          // update
          await updateContract({
            schema,
            id: this.contractModal._id,
          });
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.updatedSuccessfully("Contract")
          );
          this.closeContract();
          this.initQuotingRequest();
        } else {
          // add
          schema.product = this.Contract.product;
          schema.fromContract = this.Contract._id;
          // schema.product = defaultMethods.getItemId(
          //   this.File.proposedProducts,
          //   this.currentProduct
          // );
          schema.file = this.File._id;
          await addContract({ schema, id: this.$route.params.id });
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.createdSuccessfully("Contract")
          );
          this.closeContract();
          this.initFile();
        }
      } catch (error) {
        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
    },
    successSaveContract() {
      this.initQuotingRequest();
      this.closeContract();
    },
    applyRevesementModal() {
      this.reversementModale = true
    },
    async applyBordereauModal() {
      this.selectedbordereau = {};
      await this.getContractsBordereau({
        notPayed: true,
        withoutPeriod: this.showAllFil,
        companyRepaymentDateExist: "true",
        company: defaultMethods.getItemId(
          this.Companies.docs,
          this.compagnieMethodeValue
        ),
        paymentMethodValue: this.paymentMethodValue
      });
      console.log(this.contractModal);
      this.selectedbordereau = JSON.parse(localStorage.getItem("bordereauSelect"))
      this.bordereauModal = true
    },
    async directApplyRevesementModal() {
      this.loading = true
      try {
        // alert(JSON.stringify(this.selected))
        for (let index = 0; index < this.selectedbordereau.length; index++) {
          const element = this.selectedbordereau[index];
          // alert()
          try {
            const schema = {
              sendToCommission: true,

            };

            if (element._id) {
              // update
              await updateContract({
                schema,
                id: element._id,
              });
              defaultMethods.dispatchSuccess(
                this.$store,
                messages.updatedSuccessfully("Contract")
              );
              // this.closeContract();

            }
          } catch (error) {
            defaultMethods.dispatchError(this.$store);
          }

        }
        await this.getContractsBordereau({
          notPayed: true,
          withoutPeriod: this.showAllFil,
          companyRepaymentDateExist: "true"
        });
        this.selectedbordereau = {}
      } catch (error) {
        console.log(error)
      }
      finally {
        this.selectedbordereau = {}
        window.localStorage.removeItem('bordereauSelect');
        // this.printDocChèque = false
        this.loading = false


      }
    },
    async printApplyBordereauModal() {

      this.loading = true
      try {
        // alert(JSON.stringify(defaultMethods.getDocItemsId(this.selectedbordereau)))
        const schema = {
          ids: defaultMethods.getDocItemsId(this.selectedbordereau),
          paymentMethod: this.paymentMethodValue,
          company: this.compagnieMethodeValue,
        }
        for (let index = 0; index < this.selectedbordereau.length; index++) {
          const element = this.selectedbordereau[index];
          // alert(JSON.stringify(element._id))
          try {
            const schema = {
              sendToCommission: true,
            };

            if (element._id) {
              // update
              await updateContract({
                schema,
                id: element._id,
              });
              // defaultMethods.dispatchSuccess(
              //   this.$stor,
              //   messages.updatedSuccessfully("Contract")
              // );
              // this.closeContract();

            }
          } catch (error) {
            defaultMethods.dispatchError(this.$store);
          }

        }
        this.selectedbordereau = {}
        await this.getContractsBordereau({
          notPayed: true,
          withoutPeriod: this.showAllFil,
          companyRepaymentDateExist: "true"
        });
        await this.printOfferDoc({
          schema
        })
        // alert('ok')
      } catch (error) {
        console.log(error)
      }
      finally {
        this.selectedbordereau = {}
        window.localStorage.removeItem('bordereauSelect');
        // this.printDocChèque = false
        this.loading = false


      }
    },
    applyEncaissementModal() {
      this.cancelDialog = true
    },
    async applyEncaissemnt() {
      this.loading = true
      try {
        // alert(JSON.stringify(this.selected))
        for (let index = 0; index < this.selected.length; index++) {
          const element = this.selected[index];
          // alert()
          try {
            const schema = {
              primeRepaymentDate: this.reversementData.primeRepaymentDate,
              companyRepaymentDate: this.reversementData.companyRepaymentDate,
              mailNumberReversement: this.reversementData.mailNumberReversement,
              paymentMethod: this.reversementData.paymentMethod,
              checkNumber: this.reversementData.checkNumber,
              bank: this.reversementData.bank,

            };

            if (element._id) {
              // update
              await updateContract({
                schema,
                id: element._id,
              });
              defaultMethods.dispatchSuccess(
                this.$store,
                messages.updatedSuccessfully("Contract")
              );
              // this.closeContract();

            }
          } catch (error) {
            defaultMethods.dispatchError(this.$store);
          }

        }
        // await this.printOfferDoc({
        //   ids: defaultMethods.getDocItemsId(this.selected),
        // });
        this.initQuotingRequest();
        this.reversementData = {}
        this.cancelDialog = false
        this.reversementModale = false
        this.selected = {}
      } catch (error) {
        console.log(error)
      }
      finally {
        this.selected = {}
        window.localStorage.removeItem('encaisementSelect');
        // this.printDocChèque = false
        this.loading = false


      }
    },
    async applyRevesement() {
      this.loading = true
      try {
        // alert(JSON.stringify(this.selected))
        for (let index = 0; index < this.selectedReverse.length; index++) {
          const element = this.selectedReverse[index];
          // alert()
          try {
            const schema = {
              // primeRepaymentDate: this.reversementData.primeRepaymentDate,
              companyRepaymentDate: this.reversementData.companyRepaymentDate,
              mailNumberReversement: this.reversementData.mailNumberReversement,
              paymentMethod: this.reversementData.paymentMethod,
              checkNumber: this.reversementData.checkNumber,
              bank: this.reversementData.bank,

            };

            if (element._id) {
              // update
              await updateContract({
                schema,
                id: element._id,
              });
              defaultMethods.dispatchSuccess(
                this.$store,
                messages.updatedSuccessfully("Contract")
              );
              // this.closeContract();

            }
          } catch (error) {
            defaultMethods.dispatchError(this.$store);
          }

        }
        // await this.printOfferDoc({
        //   ids: defaultMethods.getDocItemsId(this.selectedReverse),
        // });
        this.initQuotingRequest();
        this.reversementData = {}
        this.cancelDialog = false
        this.reversementModale = false
        this.selectedReverse = {}
      } catch (error) {
        console.log(error)
      }
      finally {
        this.selectedReverse = {}
        window.localStorage.removeItem('reversementSelect');
        // this.printDocChèque = false
        this.loading = false


      }
    },
    closeContract() {
      this.contractDialog = false;
      this.seedCtr();
      this.initQuotingRequest();
      // this.currentProduct = null;
      this.incorporationDialog = false;
      this.incorporationModal = {};
      this.withDrawModal = false;
      this.regulationDialog = false;
      this.pbDialog = false;
    },
    editItemFormat(item) {
      item = defaultMethods.arrayFieldsToInteger(item);
      this.contractModal.totalPrime = item.totalPrime;
      this.contractModal.netPrime = item.netPrime;
      this.contractModal.cdeaoPrime = item.cdeaoPrime;
      this.contractModal.accessory100 = item.accessory100;
      this.contractModal.accessory50 = item.accessory50;
    },
    editItem(item) {
      this.contractModal = Object.assign({}, item);
      this.editItemFormat(item);
      if (this.Companies && this.Companies.docs) {
        this.contractModal.company = this.contractModal.company.name;
        // alert(this.Contract.productName)
      }
      switch (this.Contract.productName) {
        case "ASSURANCE CAUTION":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;
        case "ASSURANCE CREDIT":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;
        case "ASSURANCE CREDIT BAIL":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;
        case "MALADIE":
          {
            this.categorie = ["MALADIE", "GESTION CONFIEE"];
          }
          break;
        case "ASSURANCES TRANSPORTS":
          {
            this.categorie = ["TERRESTRE", "MARITIME", "AERIEN", "FERROVIAIRE"];
          }
          break;
        case "AUTOMOBILE":
          {
            this.categorie = ["FLOTTE AUTO", "MONO AUTO", "FLOTTE MOTO", "MONO MOTO "];
          }
          break;


        case "BRIS DE MACHINE":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;
        case "FAUX PAIEMENTS":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;
        case "GLOBALE DE BANQUE":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;


        case "GLOBALE DOMMAGES":
          {
            this.categorie = ["INCENDIE"];
          }
          break;
        case "INDEMNITE DE FIN DE CARRIERE":
          {
            this.categorie = ["ASSURANCES DE PERSONNES"];
          }
          break;
        case "INDIVIDUELLE ACCIDENTS CORPORELS":
          {
            this.categorie = ["ASSURANCES DE PERSONNES"];
          }
          break;


        case "MULTIRISQUE HABITATION":
          {
            this.categorie = [
              "INCENDIE"
            ];
          }
          break;
        case "MULTIRISQUE PROFESSIONNELLE":
          {
            this.categorie = [
              "INCENDIE"
            ];
          }
          break;





        case "PREVOYANCE DECES":
          {
            this.categorie = [
              "ASSURANCES DE PERSONNES"
            ];
          }
          break;
        case "RC CHEF D'ENTREPRISE":
          {
            this.categorie = ["RESPONSABILITE"];
          }
          break;
        case "RC CHEF DE FAMILLE":
          {
            this.categorie = ["RESPONSABILITE"];
          }
          break;
        case "RESPONSABILITE CIVILE DECENNALE":
          {
            this.categorie = ["RESPONSABILITE"];
          }
          break;
        case "RC EXPLOITATION":
          {
            this.categorie = ["RESPONSABILITE"];
          }
          break;
        case "PREVOYANCE PLUS":
          {
            this.categorie = ["ASSURANCES DE PERSONNES"];
          }
          break;
        case "RC PROFESSIONNELLE":
          {
            this.categorie = ["RESPONSABILITE"];
          }
          break;
        case "RC EVENEMENTS SPORTIFS":
          {
            this.categorie = ["RESPONSABILITE"];
          }
          break;
        case "RESPONSABILITE CIVILE":
          {
            this.categorie = ["RESPONSABILITE"];
          }
          break;


        case "TOUS RISQUES MONTAGE/ESSAI":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;
        case "VOL ":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;



        case "RC SCOLAIRE":
          {
            this.categorie = ["RESPONSABILITE"];
          }
          break;
        case "RETRAITE COMPLEMENTAIRE":
          {
            this.categorie = ["ASSURANCE DE PERSONNES"];
          }
          break;

        case "TOUS DOMMAGES SAUF":
          {
            this.categorie = ["INCENDIE"];
          }
          break;
        case "TOUS RISQUES CHANTIER":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;
        case "ASSISTANCE AU VOYAGE":
          {
            this.categorie = ["ASSURANCE DE PERSONNES"];
          }
          break;



        case "VIOLENCE POLITIQUE":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;
        case "RC TRANSPORTEUR":
          {
            this.categorie = ["RESPONSABILITE"];
          }
          break;
        case "TRANSPORT DE FONDS":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;
        case "DJIGUIYA":
          {
            this.categorie = ["MALADIE"];
          }
          break;
        case "EVACUATION SANITAIRE":
          {
            this.categorie = ["MALADIE"];
          }
          break;


        case "ASSURANCE MOYEN DE PAIEMENT":
          {
            this.categorie = ["DOMMAGES AUX BIENS"];
          }
          break;






        case "AUTOFINANCEMENT":
          {
            this.categorie = ["HONORAIRES PAR BENEFICIAIRE", "HONORAIRES MONTANT FIXE", "HONORAIRES MONTANT NOMINAL", "HONORAIRES CARTE SANTE", "HONORAIRES DE REGULARISATION"];
          }
          break;
        case "INCENDIE SIMPLE":
          {
            this.categorie = ["INCENDIE"];
          }
          break;
        case "MULTIRISQUE INDUSTRIELLE":
          {
            this.categorie = ["INCENDIE"];
          }
          break;
        case "AUTOMOBILE TPV":
          {
            this.categorie = ["FLOTTE AUTO", "MONO AUTO"];
          }
          break;
        case "ASSISTANCE":
          {
            this.categorie = ["ASSURANCES DE PERSONNES"];
          }
          break;
        case "MOGOBAYA":
          {
            this.categorie = ["MALADIE"];
          }
          break;
        case "IKENEYA":
          {
            this.categorie = ["MALADIE"];
          }
          break;
        case "HONORAIRES BONUS COMMISSION":
          {
            this.categorie = ["BONUS /MALUS"];
          }
          break;
        case "TEMPORAIRE DECES":
          {
            this.categorie = ["ASSURANCES DE PERSONNES"];
          }
          break;
        case "WGARAGE":
          {
            this.categorie = ["FLOTTE AUTO"];
          }
          break;
      }

      this.contractDialog = true;
    },

    initPersonnelForm() {
      this.name = "";
      this.email = "";
      this.contact = "";
      this.birthday = "";
    },
    // Reset the panel
    none() {
      this.panel = [];
    },
    getEventColor(event) {
      return event.color;
    },
    setToday() {
      this.focus = "";
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        requestAnimationFrame(() =>
          requestAnimationFrame(() => (this.selectedOpen = true))
        );
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        requestAnimationFrame(() => requestAnimationFrame(() => open()));
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    },
    updateRange({ start, end }) {
      const events = [];

      const min = new Date(`${start.date}T00:00:00`);
      const max = new Date(`${end.date}T23:59:59`);
      const days = (max.getTime() - min.getTime()) / 86400000;
      const eventCount = this.rnd(days, days + 20);

      for (let i = 0; i < eventCount; i++) {
        const allDay = this.rnd(0, 3) === 0;
        const firstTimestamp = this.rnd(min.getTime(), max.getTime());
        const first = new Date(firstTimestamp - (firstTimestamp % 900000));
        const secondTimestamp = this.rnd(2, allDay ? 288 : 8) * 900000;
        const second = new Date(first.getTime() + secondTimestamp);

        events.push({
          name: this.names[this.rnd(0, this.names.length - 1)],
          start: first,
          end: second,
          color: this.colors[this.rnd(0, this.colors.length - 1)],
          timed: !allDay,
        });
      }

      this.events = events;
    },
    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a;
    },

    addProspect() {
      this.editedIndex = -1;
      this.fileModal = {
        birthday: "",
        prospects: [],
      };
      this.fileDialog = true;
    },
    updateProspect(item) {
      this.editedIndex = 1;
      this.fileModal = Object.assign({}, item);
      this.fileDialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.prospectdata.indexOf(item);
      this.fileModal = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.prospectdata.splice(this.editedIndex, 1);
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.fileModal = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.fileModal = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.prospectdata[this.editedIndex], this.fileModal);
      } else {
        this.prospectdata.push(this.fileModal);
      }
      this.close();
    },
  },
};
</script>

<style scoped></style>
